"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("@active/react-utils/i18n");
var _LabelDropdownButton = _interopRequireDefault(require("./LabelDropdownButton"));
var _InputClearButton = _interopRequireDefault(require("../InputClearButton"));
var _Tag = _interopRequireDefault(require("../Tag"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TagDropdownButton = function TagDropdownButton(_ref) {
  var children = _ref.children,
    id = _ref.id,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    presenter = _ref.presenter,
    disabled = _ref.disabled,
    renderValue = _ref.renderValue,
    size = _ref.size,
    value = _ref.value,
    renderTag = _ref.renderTag;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var onRemoveTag = (0, _react.useCallback)(function (tagValue) {
    onChange === null || onChange === void 0 || onChange(presenter.emitValue(tagValue, value, children));
  }, [children, onChange, presenter, value]);
  var onRemoveAll = (0, _react.useCallback)(function () {
    onChange === null || onChange === void 0 || onChange(null);
  }, [onChange]);
  var tagOptions = {
    size: size,
    disabled: disabled,
    deletable: true,
    onDelete: onRemoveTag
  };
  return !presenter.hasValue(value) ? /*#__PURE__*/_react["default"].createElement(_LabelDropdownButton["default"], {
    id: id,
    placeholder: placeholder,
    presenter: presenter,
    renderValue: renderValue,
    value: value
  }, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-group"
  }, value.map(function (itemValue) {
    var label = presenter.labelFor(children)(itemValue);
    return renderTag ? renderTag({
      value: itemValue,
      label: label
    }, tagOptions) : /*#__PURE__*/_react["default"].createElement(_Tag["default"], (0, _extends2["default"])({
      value: itemValue,
      key: itemValue
    }, tagOptions), label);
  })), /*#__PURE__*/_react["default"].createElement(_InputClearButton["default"], {
    "aria-label": i18n('react-ui.common.dropdown.label.tag.clear.all'),
    className: "dropdown-clear-tags-btn",
    "data-testid": "clear-all-btn",
    disabled: disabled,
    onClear: onRemoveAll
  }));
};
var _default = exports["default"] = TagDropdownButton;